<template>
  <div>
    <br>
    <div class="columns">
      <div class="column is-8">


        <div class="columns is-multiline" v-for="(validatorItem, index) in formValidator.validators" style="border-bottom: 1px solid #dbdbdb;
        padding-bottom: 12px;">
          <div class="column is-6">
            <b-field label="Validation method">
              <b-select
                placeholder="Select the validate method"
                expanded
                v-model="validatorItem.validator"
                required
              >
                <option
                  v-for="validator in validators"
                  v-if="isAvailableValidator(formTestType.testType.testMethod.alias, validator)"
                  :value="validator"
                  :key="validator.alias">
                  {{ validator.name }}
                </option>
              </b-select>
            </b-field>
          </div>

          <div class="column is-6" v-for="validatorConfig in validatorItem.validator.validatorConfig">
            <b-field :label="validatorConfig.name" v-if="validatorConfig.type==='select'" :message="validatorConfig.description">
              <b-select expanded v-model="validatorItem.config[validatorConfig.key]" :required="validatorConfig.required">
                <option
                  v-for="(value, key) in validatorConfig.options"
                  :value="key"
                  :key="key">
                  {{ value }}
                </option>
              </b-select>
            </b-field>

            <b-field v-else :label="validatorConfig.name" :message="validatorConfig.description">
              <b-input
                v-model="validatorItem.config[validatorConfig.key]"
                :required="validatorConfig.required">
              </b-input>
            </b-field>
          </div>

          <div class="column is-12">
            <b-button size="is-small"
                      @click="removeValidator(index)"
                      icon-left="trash-alt">
              Delete
            </b-button>
          </div>


          <hr>
        </div>


        <div class="column is-12">
          <b-button icon-left="plus" @click="addValidator">
            Add validator
          </b-button>
        </div>
      </div>
      <div class="column is-3">
        <b-message :title="'Inherited validators'" v-if="formTestType.testType.validators">
          <div v-for="validator of formTestType.testType.validators">
            <b>{{getValidatorName(validator.id)}}</b>
            <ul>
              <li v-for="(value, configParamKey) in validator.validatorConfig">
                - {{getConfigParamName(validator.id, configParamKey)}}: {{value}}
              </li>
            </ul>
          </div>
        </b-message>
      </div>

    </div>

  </div>
</template>

<script>

import ValidatorService from "@/services/ValidatorService";
import isAvailableValidator from "@/mixins/isAvailableValidator";

export default {
  name: 'Validator',
  mixins: [isAvailableValidator],
  data () {
    return {
      formValidator: {},
      formTestType: {},
      validators: [],
    }
  },

  components: {

  },

  created() {
    this.getValidators();
    this.formValidator = this.$store.getters['testJob/formValidator'];
    this.formTestType = this.$store.getters['testJob/formTestType'];
  },

  methods: {
    getValidators() {
      ValidatorService.getList()
        .then(response => {
          this.validators = response.data
        })
    },
    addValidator() {
      this.$store.dispatch('testJob/addValidator')
    },

    removeValidator(index) {
      this.$store.dispatch('testJob/removeValidator', index)
    },

    getValidatorName(validatorId) {
      for (let validator of this.validators) {
        if (validator._id === validatorId) {
          return validator.name;
        }
      }
    },

    getConfigParamName(validatorId, configParamKey) {
      for (let validator of this.validators) {
        if (validator._id === validatorId) {
          for (let configParam of validator.validatorConfig) {
            if (configParam.key === configParamKey) {
              return configParam.name;
            }
          }
        }
      }
    }
  }
}
</script>
